import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronUp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	className: "chevron-up",
	xmlns: "http://www.w3.org/2000/svg",
	width: "30px",
	viewBox: "0 0 32 32",
	fill: "#000000",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "chevron_1_",
		children: /* @__PURE__ */ _jsx("path", { d: "M16,11c-0.3,0-0.5,0.1-0.8,0.3l-9.7,7.5C5,19.2,4.9,20,5.3,20.6c0.4,0.5,1.2,0.6,1.8,0.2l8.9-6.9l9,6.9 c0.5,0.4,1.3,0.3,1.8-0.2c0.4-0.5,0.3-1.3-0.2-1.8l-9.8-7.5C16.5,11.1,16.2,11,16,11z" })
	})]
});
const ForwardRef = forwardRef(SvgChevronUp);
export default ForwardRef;
